module.exports = __webpack_public_path__ + "static/media/secure.b1bb2770.svg";